import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'base64'
})
export class Base64Pipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    //return decodeURIComponent(atob(value));
    var texto= atob(value); 
    return decodeURIComponent(texto);
  }

}
